<!-- 场所及设备情况表 -->

<template>
  <div class="tabCage table6E">
    <div class="tabTtl">
      <span v-if="pressType == 1">表 1-6：重点音像制品情况登记表</span>
      <span v-else>表 1-6：重点电子出版物情况登记表</span>
    </div>
    <div class="editArea">
      <el-form ref="paramCk" :model="params" :rules="rules">
        <table>
          <tr>
            <td class="edName">项目名称：</td>
            <td class="edInpBig">
              <el-input v-model="params.proName" disabled size="small"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">重点项目名称：</td>
            <td class="edInp">
              <el-select v-model="params.importantProName" disabled size="small" placeholder="请选择">
                <el-option v-for="item in dicDats['C021']" :key="item.code" :label="item.name" :value="item.code">
                </el-option>
              </el-select>
              <el-input
                v-if="dicMap['C021'][params.importantProName] == '其他'"
                disabled
                v-model="params.importantProNameOther"
                size="small"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">级别：</td>
            <td class="edInp">
              <el-select v-model="params.hjLevel" disabled size="small" placeholder="请选择">
                <el-option v-for="item in dicDats['C024']" :key="item.code" :label="item.name" :value="item.code">
                </el-option>
              </el-select>
              <el-input
                v-if="dicMap['C024'][params.hjLevel] == '其他'"
                disabled
                v-model="params.hjLevelOther"
                size="small"></el-input>
            </td>
          </tr>
          <tr>
            <td class="edName">拟定完成时间：</td>
            <td class="edInp">
              <el-date-picker
                disabled
                v-model="params.ydDate"
                align="right"
                type="date"
                size="small"
                value-format="yyyy-MM-dd"
                placeholder="选择日期">
              </el-date-picker>
            </td>
          </tr>
          <tr>
            <td class="edName">备注：</td>
            <td class="edInpTextArea">
              <el-input :rows="3" disabled type="textarea" v-model="params.remark" size="small"></el-input>
            </td>
          </tr>
        </table>
      </el-form>
    </div>
    <div class="subArea">
      <el-button @click="goBack" size="small">返回</el-button>
    </div>
  </div>
</template>

<script>
import { bsParams, paramsRule } from "@/components/LongParams/paramsEt6";
import { tabUpdate6, tabRead6 } from "@/api/pressRole/pressRole";
export default {
  data() {
    return {
      params: bsParams,
      rules: paramsRule,
      dicDats: {},
      submiting: false,
      pressType: this.$route.query.pressType,
      dicMap: {
        C021: {},
        C024: {},
      },
    };
  },
  methods: {
    tabReEdit: function () {
      tabRead6({ id: this.$route.query.id }).then((response) => {
        this.params = response.pimportantproducts;
      });
    },

    dictInit: function () {
      let nameArr = ["C021", "C024"];
      let newPromise = this.$store.dispatch("dictUpdate", { codeArr: nameArr, type: "arr" });
      newPromise.then((result) => {
        this.dicDats = result;
        this.dicMap["C021"] = this.$store.getters.dictionary["C021"];
        this.dicMap["C024"] = this.$store.getters.dictionary["C024"];
      });
    },

    goBack: function () {
      this.$router.go(-1);
    },
  },

  created: function () {
    this.dictInit();
    this.tabReEdit();
  },
};
</script>

<style lang="scss">
@import "src/styles/pressRoleE";
.table6E .edInp .el-textarea {
  width: 450px;
}
</style>



// WEBPACK FOOTER //
// table6.vue?78e770f2